import { toast } from 'sonner';

import { ConfirmDialog } from '@/components/ui/confirm-dialog';
import { usePagesActions } from '@/stores/pages-store';
import type { Page } from '@/types/page';

export type DeletePageTarget = Pick<Page, 'id' | 'title'>;

interface DeletePageDialogProps {
  page: DeletePageTarget | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DeletePageDialog({ page, open, onOpenChange }: DeletePageDialogProps) {
  const { deletePage } = usePagesActions();

  const handleConfirm = async () => {
    if (page?.id) await deletePage(page.id);
  };

  const handleError = () => {
    toast.error('Failed to delete page');
  };

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Delete page"
      description={
        <span>
          Are you sure you want to delete the <strong>{page?.title}</strong> page?
        </span>
      }
      confirmLabel="Delete"
      cancelLabel="Cancel"
      onConfirm={handleConfirm}
      onError={handleError}
      confirmColorScheme="destructive"
    />
  );
}
